export default __webpack_public_path__ + "static/default_og_image-1b1dc53ff7d9b27d894c7b3ee7ca679d.png";